import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

export interface CreateUserRequest {
  email: string;
  password: string;
  name: string;
  surname: string;
  userType: string;
  phoneNumber: string;
  address: string;
  country: string;
}

export interface UserDto {
  userId: string;
  email: string;
  userType: string;
  name: string | null;
  surname: string | null;
  phoneNumber: string | null;
  address: string | null;
  country: string | null;
  createdAt: Date;
  updatedAt: Date;
  accepted: boolean;
}

export interface UserListResponse {
  data: UserDto[];
  total: number;
}

export interface UserTypeDto {
  id: string;
  name: string;
  description: string | null;
  parentId: string | null;
  createdAt: Date;
  updatedAt: Date;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private endpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) {}

  createUser(userData: CreateUserRequest): Observable<any> {
    return this.http.post(`${this.endpoint}/v1/users`, userData);
  }

  getUsers(
    limit?: number,
    offset?: number,
    orderColumn?: string,
    orderDirection?: 'asc' | 'desc',
    filters?: { [key: string]: any }
  ): Observable<UserListResponse> {
    let url = `${this.endpoint}/v1/users`;
    const params = new URLSearchParams();

    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());
    if (orderColumn) params.append('orderColumn', orderColumn);
    if (orderDirection) params.append('orderDirection', orderDirection);
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value !== null && value !== undefined && value !== '') {
          params.append(key, value.toString());
        }
      }
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    return this.http.get<UserListResponse>(url);
  }

  acceptUser(userId: string): Observable<any> {
    return this.http.put(`${this.endpoint}/v1/users/${userId}/accept`, {});
  }

  deleteUser(userId: string): Observable<any> {
    return this.http.delete(`${this.endpoint}/v1/users/${userId}`);
  }

  getPendingUsers(
    limit?: number,
    offset?: number,
    orderColumn?: string,
    orderDirection?: 'asc' | 'desc'
  ): Observable<UserListResponse> {
    let url = `${this.endpoint}/v1/users`;
    const params = new URLSearchParams();

    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());
    if (orderColumn) params.append('orderColumn', orderColumn);
    if (orderDirection) params.append('orderDirection', orderDirection);
    params.append('accepted', 'false');

    url += `?${params.toString()}`;
    return this.http.get<UserListResponse>(url);
  }

  listUserTypes(): Observable<UserTypeDto[]> {
    return this.http.get<UserTypeDto[]>(`${this.endpoint}/v1/user-types`);
  }
}
